
import React, { useState, useEffect, useCallback } from "react";
import { API_URL } from "../../config";
import { DEFAULT_BODY, DEFAULT_SUBJECT } from "../../data/welcomeEmailTemplates";
import { buildWelcomeEmailPreviewHtml } from "../../utils/welcomeEmailPreview";
import "./EmailBienvenida.css";

const EmailBienvenida = () => {
  const [asunto, setAsunto] = useState("");
  const [cuerpo, setCuerpo] = useState("");
  const [logoCorreo, setLogoCorreo] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [fetchError, setFetchError] = useState("");

  const fetchConfig = useCallback(async () => {
    setFetchError("");
    try {
      const res = await fetch(`${API_URL}/api/configuracion/email-bienvenida`, {
        credentials: "include",
      });
      if (res.ok) {
        const data = await res.json();
        setAsunto(data.asunto || "");
        setCuerpo(data.cuerpo || "");
        setLogoCorreo(data.logoCorreo || "");
      } else {
        const data = await res.json();
        setFetchError(data.error || "Error al cargar la configuración");
      }
    } catch (error) {
      console.error(error);
      setFetchError("Error en el servidor. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const handleSave = async () => {
    setSaving(true);
    setMsg("");
    try {
      const res = await fetch(`${API_URL}/api/configuracion/email-bienvenida`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ asunto, cuerpo, logoCorreo }),
      });

      if (res.ok) {
        setMsg("✅ Configuración guardada correctamente");
      } else {
        const data = await res.json().catch(() => ({}));
        setMsg(`❌ ${data.error || "Error al guardar"}`);
      }
    } catch (error) {
      setMsg("❌ Error de conexión");
    } finally {
      setSaving(false);
    }
  };

  const handleReset = () => {
    if (window.confirm("¿Restaurar a los valores por defecto?")) {
      setAsunto(DEFAULT_SUBJECT);
      setCuerpo(DEFAULT_BODY);
    }
  };

  const getPreviewHtml = () => buildWelcomeEmailPreviewHtml({
    cuerpo,
    defaultBody: DEFAULT_BODY,
    logoCorreo,
  });

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="email-config-container">
      <h2>Configuración de Email de Bienvenida</h2>
      <p className="description">
        Personaliza el correo que reciben los usuarios después de validar su cuenta.
        Usa <code>{`{{nombre}}`}</code>, <code>{`{{setupUrl}}`}</code> y <code>{`{{cursosLista}}`}</code> como variables.
      </p>

      {msg && <div className="msg-box">{msg}</div>}
      {fetchError && <div className="msg-box error-box">{fetchError}</div>}

      <div className="form-group">
        <label>URL del Logo (Opcional)</label>
        <input 
          type="text" 
          value={logoCorreo} 
          onChange={(e) => setLogoCorreo(e.target.value)} 
          placeholder="https://ejemplo.com/logo.png"
        />
        {logoCorreo && <img src={logoCorreo} alt="Preview Logo" className="logo-preview-small" />}
      </div>

      <div className="form-group">
        <label>Asunto del Correo</label>
        <input 
          type="text" 
          value={asunto} 
          onChange={(e) => setAsunto(e.target.value)} 
          placeholder={DEFAULT_SUBJECT}
        />
      </div>

      <div className="form-group">
        <label>Cuerpo del Correo (HTML)</label>
        <textarea 
          className="html-editor"
          value={cuerpo} 
          onChange={(e) => setCuerpo(e.target.value)} 
          placeholder={DEFAULT_BODY}
        />
      </div>

      <div className="actions">
        <button className="btn-save" onClick={handleSave} disabled={saving}>
          {saving ? "Guardando..." : "Guardar Cambios"}
        </button>
        <button className="btn-preview" onClick={() => setShowPreview(true)}>
          👁️ Previsualizar
        </button>
        <button className="btn-reset" onClick={handleReset}>
          🔄 Restaurar Por Defecto
        </button>
      </div>

      {showPreview && (
        <div className="modal-backdrop" onClick={() => setShowPreview(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Previsualización</h3>
            <div className="preview-box">
               <div className="preview-subject"><strong>Asunto:</strong> {asunto || DEFAULT_SUBJECT}</div>
               <hr/>
               <div className="preview-body" dangerouslySetInnerHTML={{ __html: getPreviewHtml() }} />
            </div>
            <button className="btn-close" onClick={() => setShowPreview(false)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailBienvenida;
